<template>
    <div class="d-flex h-100 w-100">
        <div class="fp-sidenav">
            <ScrollPagination
                class="content-y h-100 d-flex flex-column w-100"
                :page-number="pageNumber"
                :all-pages-loaded="allPagesLoaded"
                :is-loading="isLoading || isLoadingMoreConversations"
                :has-error="hasError"
                v-on:pageNumberUpdate="pageNumberUpdated"
            >
                <FPSideNav
                    :conversationGroupsCount="conversationGroupsCount"
                    :groupConversations="groupConversations"
                    v-model:selectedGroupType="selectedGroupType"
                    v-model:selectedConversation="selectedConversation"
                    v-model:openNewConversation="openNewConversation"
                    :is-loading="isLoading"
                    :is-loading-more-conversations="isLoadingMoreConversations"
                    :loading-new-group="loadingNewGroup"
                    :page-number="pageNumber"
                    @termChanged="updateChatSearchTerm"
                />
            </ScrollPagination>
        </div>
        <section class="col px-0 h-100">
            <template v-if="openNewConversation">
                <NewConversation :selectedGroupType="selectedGroupType" />
            </template>
            <template v-else>
                <FPThreadsContainer
                    :conversationThreadsInfo="conversationThreadsInfo"
                    :selectedConversationId="selectedConversation?.id"
                    :selectedConversation="selectedConversation"
                    :selectedGroupType="selectedGroupType"
                    :isLoading="isLoading"
                    :isLoadingThreads="isLoadingThreads"
                    :familyContacts="familyContacts"
                />
            </template>
        </section>
    </div>
</template>

<style src="./FamilyPortal.scss" />
<script lang="ts" src="./FamilyPortal.ts" />
